
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class MbReportSaleByDateDialog extends Serenity.EntityDialog<MbReportSaleByDateRow, any> {
        protected getFormKey() { return MbReportSaleByDateForm.formKey; }
        protected getIdProperty() { return MbReportSaleByDateRow.idProperty; }
        protected getLocalTextPrefix() { return MbReportSaleByDateRow.localTextPrefix; }
        protected getNameProperty() { return MbReportSaleByDateRow.nameProperty; }
        protected getService() { return MbReportSaleByDateService.baseUrl; }
        protected getDeletePermission() { return MbReportSaleByDateRow.deletePermission; }
        protected getInsertPermission() { return MbReportSaleByDateRow.insertPermission; }
        protected getUpdatePermission() { return MbReportSaleByDateRow.updatePermission; }

        protected form = new MbReportSaleByDateForm(this.idPrefix);

    }
}